import React, { useRef } from 'react';
import styles from '../../styles/home.module.css';

const BankLogoSection = ({ logos }) => {
  const logoSliderRef = useRef(null);

  return (
    <div className={styles.bankLogoSection}>
      <div className={styles.logoSlider} ref={logoSliderRef}>
        {/* First set of logos */}
        {logos.map((logo, index) => (
          <img
            key={`first-${index}`}
            src={logo.src}
            alt={logo.alt}
            className={logo.className || ''}
          />
        ))}
        {/* Duplicate set for seamless scrolling */}
        {logos.map((logo, index) => (
          <img
            key={`second-${index}`}
            src={logo.src}
            alt={logo.alt}
            className={logo.className || ''}
          />
        ))}
      </div>
    </div>
  );
};

export default BankLogoSection;